class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  connectedCallback() {
    if (this.dataset.moved === 'true') return;
    this.dataset.moved = 'true';
    document.body.appendChild(this);
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  getAddedItemKey(parsedState) {
    if (parsedState && parsedState.key) return parsedState.key;
    const items = (parsedState && parsedState.items) || [];
    const parent = items.find((item) => {
      const properties = item.properties || {};
      return !properties._bundle_parent;
    });
    return (parent || items[0] || {}).key;
  }

  renderContents(parsedState) {
      this.cartItemKey = this.getAddedItemKey(parsedState);
      const sections = (parsedState && parsedState.sections) || {};
      this.getSectionsToRender().forEach((section => {
        const sectionHtml = sections[section.id];
        if (!sectionHtml) return;
        const html = this.getSectionInnerHTML(sectionHtml, section.selector);
        if (!html) return;
        if (section.id === 'cart-icon-bubble') {
          document.querySelectorAll('#cart-icon-bubble, [data-cart-icon-bubble]').forEach((el) => {
            el.innerHTML = html;
          });
          return;
        }
        const destination = document.getElementById(section.id);
        if (destination) destination.innerHTML = html;
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';
    const el = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return el ? el.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
